import { Box, Typography } from '@mui/material';
import { FC } from 'react';

interface HeaderProps {
  title: string;
  subtitle?: string;
  label: string;
  labelColor?: string;
}

const Header: FC<HeaderProps> = ({
  title,
  subtitle,
  label,
  labelColor = 'red',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography
          variant="h6"
          sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' } }}
        >
          {title}
        </Typography>
        <Typography
          ml={1}
          color="primary.main"
          variant="h6"
          sx={{ fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' } }}
        >
          {subtitle}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: labelColor,
          borderRadius: 20,
          px: 2.5,
          py: 0.2,
          display: 'inline-block',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
            color: 'white',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
